module.exports = __webpack_public_path__ + "media/images/design/images/btn_disasterbank-09d60eb75f9be9725982b13e26677125.png";